import React, { FC } from 'react';
import { useState } from 'react';
import './index.css';

interface BusBookingSummaryProps {
  bookingSummary: string | null;
}

export const BusBookingSummary: FC<BusBookingSummaryProps> = ({
  bookingSummary,
}) => {
  const [viewMore, setViewMore] = useState(true);

  const handleViewMore = () => {
    setViewMore(!viewMore);
  };

  if (!bookingSummary) {
    return null;
  }

  return (
    <div>
      <div className="busBookingSummaryContainer">
        <div
          style={{
            fontSize: '12px',
            ...(viewMore
              ? { maxHeight: '45px', overflow: 'hidden' }
              : { height: 'auto' }),
          }}
        >
          {bookingSummary}
        </div>
        <p className="busBookingSummaryButton" onClick={handleViewMore}>
          {viewMore ? 'View More' : 'Hide'}
        </p>
      </div>
    </div>
  );
};
